<template>
    <div class="GSR">
        <div class="left">
            <div class="item">
                <p class="title"><i><img src="@/assets/Analysissoftware/ic_skin_gsr@2x.png" alt=""></i>皮电电导和反应</p>
                <div class="chart">
                    <div ref="skinTemperatures" style="width: 100%;height:640px"></div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{GSRInfo.deptName}}</p>
                <p class="item">姓名：{{GSRInfo.realName}}</p>
                <p class="item">性别：{{GSRInfo.sex}}</p>
                <p class="item">年龄：{{GSRInfo.age}}</p>
            </div>

            <div class="Bloodoxygenvalue">
                <p class="title"><i><img src="@/assets/Analysissoftware/ic_skin_gsr2@2x.png" alt=""></i>非特异性皮肤电反应</p>
                <div class="average">
                    <i><img src="@/assets/Analysissoftware/ic_average@2x.png"></i>
                    <div>
                        <p>平均值</p>
                        <b>{{GSRInfo.nonspecificAvg}}</b>
                    </div>
                </div>
                <div class="other">
                    <div class="item green">
                        <span>最大值</span>
                        <b>{{GSRInfo.nonspecificMax}}</b>
                    </div>
                    <div class="item yellow">
                        <span>最小值</span>
                        <b>{{GSRInfo.nonspecificMin}}</b>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
export default{
    name:'electromechanical',
    data() {
        return {
            GSRInfo:{},
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            time:null
        }
    },
    created(){
        this.getGSRInfo()
    },
    mounted() {
        var _this=this;
        setTimeout(() => {
            _this.time=setInterval(() => {
                _this.getGSRInfo();
            }, 1000);
        }, 2000);
    },
    methods: {
        getGSRInfo(){
            this.$Http_Post('/bioassay/soft/getGSRInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.GSRInfo=res.Data;
                    this.GSPecharts(res.Data);
                }else{
                    this.$message.error(res.Message);
                }
                console.log(res)
            });
        },
        GSPecharts(data){
            var myChart = this.$echarts.init(this.$refs.skinTemperatures);
            var option = {
                tooltip: {},
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30,
                },
                legend: {
                    data: ['相位皮肤电导反应(SCR)', '基础皮肤电导水平(SCL)'],
                    textStyle: {  
                        color: '#fff'  // 设置文字颜色为红色  
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false,},  
                },
                series:[
                    {
                        name: '相位皮肤电导反应(SCR)',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: '#FF1A1A'
                            }])
                        },
                        data:data.scrList
                    },{
                        name: '基础皮肤电导水平(SCL)',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: '#FFAF1A'
                            },
                            ])
                        },
                        data: data.sclList
                    },
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style>
.GSR img{width: 100%;display:block;}
.GSR{background:#291713;display: flex;min-height: 100%;padding: 15px;}
.GSR .left{flex: auto;margin-right: 10px;}
.GSR .left .item{background: #1F2626;padding: 10px;}
.GSR .left .item .title{background: #8159DE;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.GSR .left .item .title i{width:30px;display: inline-block;margin-right: 5px;}
.GSR .left .item .chart{background: #372C26;}
.GSR .right{width:240px;display: inline-block;}
.GSR .right .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.GSR .right .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.GSR .right .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.GSR .right .startBtn{width: 100%;margin: 10px 0;}
.GSR .right .Bloodoxygenvalue{background: rgba(255, 255, 255, 0.05);margin-top: 10px;}
.GSR .right .Bloodoxygenvalue .title{background: #D6811A;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.GSR .right .Bloodoxygenvalue .title i{width:30px;display: inline-block;margin-right: 5px;}
.GSR .right .Bloodoxygenvalue .average{background:url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;display: flex;align-items: center;justify-content: center;padding: 20px 0;margin: 30px 20px;}
.GSR .right .Bloodoxygenvalue .average i{width: 40px;margin-right: 10px;}
.GSR .right .Bloodoxygenvalue .average p{font-size: 20px;color: #239FC2;}
.GSR .right .Bloodoxygenvalue .average b{font-size: 44px;color: #239FC2;}
.GSR .right .Bloodoxygenvalue .other{display: flex;padding-bottom: 30px;margin: 0 10px;}
.GSR .right .Bloodoxygenvalue .other .item{background:url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;margin: 0 10px;    text-align: center;}
.GSR .right .Bloodoxygenvalue .other .item span{font-size: 16px;padding: 0 10px;float: left;}
.GSR .right .Bloodoxygenvalue .other .item b{font-size: 36px;text-align: center;}
.GSR .el-dialog__header{background: #D6811A;text-align: center;}
.GSR .el-dialog__title,.skintemperature .el-dialog__close{color: #fff;}
.GSR .Monitoringresults{margin:10px;display: flex;}
.GSR .Monitoringresults .item{background: #F2F2F2;text-align: center;margin: 0 1px;padding: 60px 0;width: -webkit-fill-available;}
.GSR .Monitoringresults .item p{font-size: 24px;padding-bottom: 25px;}
.GSR .Monitoringresults .item b{font-size: 48px;}
.green{color: #2BB361;}
.yellow{color: #E3C21B;}
.blue{color: #239FC2;}
.orange{color: #D6811A;}
</style>